import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
    CmpsBadgeModule,
    CmpsCheckboxModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsRadioModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsDateTimePickerModule } from '../../common/component/datetime-picker';
import { CmpsSearchInputModule } from '../../common/search-input';
import { CmpsLazyRouterModule } from '../../route.module';
import { CmpsPopulationSelectModule } from '../../user/population-select';
import { CmpsReportBuilderSelectionModule } from '../builder-selection';

import { BuilderComponent } from './component/builder/builder.component';
import { CacheDateComponent } from './component/cache-date/cache-date.component';
import { CacheMetricComponent } from './component/cache-metric/cache-metric.component';
import { CardComponent } from './component/card/card.component';
import { DataSourceComponent } from './component/data-source/data-source.component';
import { DimensionComponent } from './component/dimension/dimension.component';
import { PresetsDialogComponent } from './component/presets-dialog/presets-dialog.component';
import { RawDateComponent } from './component/raw-date/raw-date.component';
import { ReportTypeComponent } from './component/report-type/report-type.component';
import { SavePresetDialogComponent } from './component/save-preset-dialog/save-preset-dialog.component';
import { ScheduleDialogComponent } from './component/schedule-dialog/schedule-dialog.component';
import { CacheDatePipe } from './pipe/cache-date.pipe';

@NgModule({
    declarations: [
        BuilderComponent,
        CacheDateComponent,
        CacheDatePipe,
        CacheMetricComponent,
        CardComponent,
        DataSourceComponent,
        DimensionComponent,
        PresetsDialogComponent,
        RawDateComponent,
        ReportTypeComponent,
        SavePresetDialogComponent,
        ScheduleDialogComponent,
    ],
    imports: [
        CmpsBadgeModule,
        CmpsCheckboxModule,
        CmpsCommonModule,
        CmpsDateTimePickerModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyRouterModule,
        CmpsPopulationSelectModule,
        CmpsRadioModule,
        CmpsReportBuilderSelectionModule,
        CmpsSearchInputModule,
        CmpsTooltipModule,
        CommonModule,
        FormsModule,
    ],
})
export class CmpsReportBuilderModule {}
